// Rxjs imports
import { Observable, Subject } from 'rxjs';
// Common imports
import { Utils } from 'cc-common';
import * as i0 from "@angular/core";
/**
 * Helper class to maintain selected entity and form context for Corporate cirabooks module
 */
export class CCBHelperService {
    constructor() {
        this._subjectSelectedEntity = new Subject();
        this._subjectFilterFormReady = new Subject();
        this._subjectWidgetContext = new Subject();
        this._updateSecurityInfo = new Subject();
    }
    //#region CCB Context methods
    getContext() {
        return new Observable((observer) => {
            this._subjectSelectedEntity.subscribe((context) => observer.next(context));
        });
    }
    getLocalContext() {
        return this._selectedEntity;
    }
    updateContext(context) {
        this._selectedEntity = null;
        if (Utils.notNullAndDefined(context) && Utils.notNullAndDefined(context.entityId)) {
            this._selectedEntity = context.entityId;
        }
    }
    //#endregion
    //#region Widget Context methods
    /**
     * @param context Widget context contains selected entity id, entity name and widget id
     */
    updateWidgetContextSubject(context) {
        this._subjectWidgetContext.next(context);
    }
    getWidgetContextSubject() {
        return this._subjectWidgetContext;
    }
    //#endregion
    //#region Entity Context methods
    updateSelectedEntitySubject(entity) {
        this._selectedEntity = entity;
        this._subjectSelectedEntity.next(entity);
    }
    getSelectedEntitySubject() {
        return this._subjectSelectedEntity;
    }
    getSelectedEntity() {
        return this._selectedEntity;
    }
    //#endregion
    //#region Form Context methods
    getSubjectFilterFormReady() {
        return this._subjectFilterFormReady;
    }
    updateSubjectFilterFormReady(filterForm) {
        this._filterForm = filterForm;
        this._subjectFilterFormReady.next(true);
    }
    getFilterForm() {
        return this._filterForm;
    }
    getSecurityInfo() {
        return this._updateSecurityInfo;
    }
    updateSecurityInfo(value) {
        this._updateSecurityInfo.next(value);
    }
}
CCBHelperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CCBHelperService_Factory() { return new CCBHelperService(); }, token: CCBHelperService, providedIn: "root" });
